'use client';

import { c as _c } from "react/compiler-runtime";
import { Activity, useState } from 'react';
import { getENV, useCacheKey, useOptimizely } from '@libs/common-next';
import { CacheKey } from './cache-key';
import { Flags } from './flags';
import { Fold } from './fold';
import { Preview } from './preview';
import { Tabs } from './tabs';
export function DevTools() {
  const $ = _c(22);
  const {
    cookies
  } = useCacheKey();
  const {
    instance
  } = useOptimizely();
  const [tab, setTab] = useState("Feature flags");
  const debug = cookies.has("x-petm-devtools");
  let t0;
  if ($[0] !== instance) {
    t0 = JSON.parse(instance?.getOptimizelyConfig()?.getDatafile() ?? "{}");
    $[0] = instance;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const dataFile = t0;
  let t1;
  if ($[2] !== tab) {
    t1 = active => tab === active ? "visible" : "hidden";
    $[2] = tab;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const active_0 = t1;
  const {
    NEXT_PUBLIC_APP_ENV
  } = getENV();
  if (NEXT_PUBLIC_APP_ENV === "prod" || !debug || !Object.keys(dataFile).length) {
    return null;
  }
  let t2;
  if ($[4] !== tab) {
    t2 = <Tabs value={tab} onChange={setTab} />;
    $[4] = tab;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = active_0("Feature flags");
  let t4;
  if ($[6] !== dataFile) {
    t4 = <Flags dataFile={dataFile} />;
    $[6] = dataFile;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <Activity mode={t3}>{t4}</Activity>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = active_0("Cache Key");
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CacheKey />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6) {
    t8 = <Activity mode={t6}>{t7}</Activity>;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = active_0("Site Preview");
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Preview />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t9) {
    t11 = <Activity mode={t9}>{t10}</Activity>;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t2 || $[19] !== t5 || $[20] !== t8) {
    t12 = <Fold>{t2}{t5}{t8}{t11}</Fold>;
    $[17] = t11;
    $[18] = t2;
    $[19] = t5;
    $[20] = t8;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
}